search.$inject = ['$http', 'configuration', '$q']

export default function search($http, config, $q) {
  var endPoint = config.apiEndPoint
  return {
    //Backend will only search values that are provided, if you only want to search by name or only by email just give an empty string for the other value
    searchUsers: function(name, email, ssoExternalId, size) {
      name = name.toLowerCase()
      email = email.toLowerCase()
      ssoExternalId = ssoExternalId.toLowerCase()
      var deferred = $q.defer()
      console.log(
        endPoint +
          '/elasticsearch/searchusers?name=' +
          encodeURIComponent(name) +
          '&email=' +
          encodeURIComponent(email) +
          '&ssoExternalId=' +
          encodeURIComponent(ssoExternalId) +
          '&size=' +
          encodeURIComponent(size)
      )
      $http
        .get(
          endPoint +
            '/elasticsearch/searchusers?name=' +
            encodeURIComponent(name) +
            '&email=' +
            encodeURIComponent(email) +
            '&ssoExternalId=' +
            encodeURIComponent(ssoExternalId) +
            '&size=' +
            encodeURIComponent(size)
        )
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject({
              status: 'error',
              message: response.data
            })
          }
        )
      return deferred.promise
    },
    searchDomains: function(name, size) {
      name = name.toLowerCase()
      var deferred = $q.defer()
      $http
        .get(
          endPoint +
            '/elasticsearch/searchdomains?name=' +
            encodeURIComponent(name) +
            '&size=' +
            encodeURIComponent(size)
        )
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject({
              status: 'error',
              message: response.data
            })
          }
        )
      return deferred.promise
    }
  }
}
